import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=deddfd56&scoped=true"
import script from "./search-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./search-bar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=deddfd56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deddfd56",
  null
  
)

export default component.exports